// extracted by mini-css-extract-plugin
export default {"zoomModal":"N2-z","image":"O2-z","button":"P2-z","isOverlayShown":"Q2-z"};